import { sortBy, uniqBy } from 'lodash'
const monsterSort = (monsters, userDefaultTeamId) => {
    return sortBy(monsters, [
        m => {
            if (m.teamId === userDefaultTeamId) return 0
            return m.teamId
        },
        'section',
        'name',
    ])
}
const sortByDefaultTeam = (entityArray, userDefaultTeamId) => {
    if (!userDefaultTeamId || userDefaultTeamId === -1) return entityArray
    let orderedentities = entityArray.sort((a, b) => {
        let ownedA = a.teamId === userDefaultTeamId
        let ownedB = b.teamId === userDefaultTeamId
        if (ownedA === ownedB) {
            let nameA = a.name.toUpperCase()
            let nameB = b.name.toUpperCase()
            if (nameA < nameB) {
                return -1
            }
            if (nameA > nameB) {
                return 1
            }
            // names must be equal??
            return 0
        }
        return ownedA ? -1 : 1
    })
    return orderedentities
}
const uniqueTeamsForEntities = (entities, includeAll) => {
    var teams = []
    if (includeAll) teams.push({ value: 0, text: 'All' })
    let entityTeams = entities
        .filter(x => x.teamId !== null && x.teamName !== null)
        .map(x => {
            return { value: x.teamId, text: x.teamName }
        })
    let uniqueTeams = uniqBy(entityTeams, 'value')
    teams = teams.concat(uniqueTeams)
    return teams
}

export default {
    monsterSort,
    sortByDefaultTeam,
    uniqueTeamsForEntities,
}
